import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-body-1 font-weight-bold"
}
const _hoisted_2 = {
  key: 0,
  class: "text-primary_alt text-h6"
}
const _hoisted_3 = { key: 1 }

import MDynamicForm from '@/components/molecules/MDynamicForm.vue'
	import MOptionalsForm from '@/components/molecules/MOptionalsForm.vue'
	import TConfirmation from '@/components/templates/TConfirmation.vue'
	import WarehouseEvaluationApplications from './components/WarehouseEvaluationApplications.vue'
	import OGridSelectEntity from '@/components/organism/OGridSelectEntity.vue'
	import WarehouseEvaluationProduct from './components/WarehouseEvaluationProduct.vue'
	import WarehouseEvaluationMachines from './components/WarehouseEvaluationMachines.vue'
	import WarehouseEvaluationPackages from './components/WarehouseEvaluationPackages.vue'
	import WarehouseEvaluationWastes from './components/WarehouseEvaluationWastes.vue'

	import type { ObjectContext } from '@/global'
	import type { ComputedRef } from 'vue'

	import * as UTIL from '@/util'

	import { ref, reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		item: { type: Object, default: null, required: true }
	},
  setup(__props) {

const $props = __props

	const { $t, $store, $router, $route, isNew, isCopy, tabSelected, mainClick, loading, goToMainView } = useGeneral()

	

	const state = reactive({
		panel: 0,
		confirmDialog: false,
		item: {
			warehouse_id: undefined
		},
		optionals: [],
		optionalsToDelete: []
	})

	watch(
		() => $props.item,
		(val: any) => (state.item = val)
	)
	const warehouseEvalutionItem: ComputedRef<string> = computed(() => $store.getters['warehouse_evaluations/GET_ITEM'])

	watch(
		() => warehouseEvalutionItem.value,
		(val: any) => (state.item = val)
	)

	const tabSelectedElement: ComputedRef<string> = computed(() => $store.getters['roles/GET_TAB_ELEMENTS'][tabSelected.value])

	const formTitleKey: ComputedRef<string> = computed(() => $store.getters['forms/GET_FORM_TITLE_KEYS'][tabSelected.value])
	// @ts-ignore
	const titleValue = computed(() => state.item[formTitleKey.value])
	function updateTitle() {
		$store.dispatch('forms/setFormTitle', titleValue.value || '')
	}
	watch(
		() => titleValue.value,
		() => updateTitle()
	)

	function init() {
		$store.dispatch('forms/initSteps', { tabSelected: tabSelected.value })
	}
	init()

	const formStep = computed(() => $store.getters['forms/GET_STEP'])
	const formIsLastStep = computed(() => $store.getters['forms/IS_LAST_STEP'])

	function setStep() {
		state.panel = 0
		$store.dispatch('forms/setStep', formStep.value + 1)
	}

	const sections: ComputedRef = computed(() => {
		const inputs = {
			1: [
				{
					id: 'warehouse_selection',
					tabSelected: 'warehouses',
					component: OGridSelectEntity
				}
			],
			// 2: [
			// {
			// 	id: 'supply_information',
			// 	title: 'Form_section_warehouse_evaluations_general_warehouse_consumption',
			// 	expansion_panel: true,
			// 	components: [
			// 		{
			// 			title: 'Form_section_warehouse_evaluations_consumption',
			// 			table: true,
			// 			keys: ['consumption_period', 'water_consumption_quantity', 'electricity_consumption_quantity']
			// 		},
			// 		{
			// 			title: 'Form_section_warehouse_evaluations_machinery_and_use',
			// 			description: 'Form_section_warehouse_evaluations_machinery_and_use_description',
			// 			component: WarehouseEvaluationMachines
			// 		}
			// 	]
			// },
			2: [
				{
					id: 'warehouse_evaluation_name',
					table: true,
					expansion_panel: false,
					sizeColumnsToFit: true,
					keys: ['warehouse_evaluation_name']
				},
				{
					id: 'supply_information',
					title: 'Form_section_warehouse_evaluations_consumption',
					table: true,
					panel: 1,
					expansion_panel: true,
					keys: ['consumption_period', 'water_consumption_quantity', 'electricity_consumption_quantity']
				},
				{
					id: 'machinery_information',
					title: 'Form_section_warehouse_evaluations_machinery_and_use',
					description: 'Form_section_warehouse_evaluations_machinery_and_use_description',
					panel: 2,
					expansion_panel: true,
					component: WarehouseEvaluationMachines
				}
			],
			3: [
				{
					id: 'product_information',
					title: 'Form_section_warehouse_evaluations_product',
					panel: 1,
					expansion_panel: true,
					component: WarehouseEvaluationProduct
				},
				{
					id: 'post_harvest_applications_information',
					title: 'Form_section_warehouse_evaluations_post_harvest_applications',
					panel: 2,
					expansion_panel: true,
					component: WarehouseEvaluationApplications,
					type: 'post_harvest'
				},
				{
					id: 'warehouse_applications_information',
					title: 'Form_section_warehouse_evaluations_warehouse_applications',
					panel: 3,
					expansion_panel: true,
					component: WarehouseEvaluationApplications,
					type: 'warehouse'
				},
				{
					id: 'packages_information',
					title: 'Form_section_warehouse_evaluations_packages',
					panel: 4,
					expansion_panel: true,
					component: WarehouseEvaluationPackages
				},
				{
					id: 'wastes_information',
					title: 'Form_section_warehouse_evaluations_wastes',
					panel: 5,
					expansion_panel: true,
					component: WarehouseEvaluationWastes
				},
				{
					id: 'farm_to_gate_information',
					title: 'Form_section_warehouse_evaluations_farm_to_gate',
					panel: 6,
					expansion_panel: true,
					table: true,
					keys: ['footprint4_hydric', 'footprint4_carbon']
				}
			]
		}
		// @ts-ignore
		return inputs[formStep.value] || []
	})

	const sectionKeys = computed(() => {
		let items: Array<string> = []
		// @ts-ignore
		sections.value.forEach(e => (items = items.concat(e.keys || [])))
		return items
	})

	function deleteKey(key: string) {
		// @ts-ignore
		if (key && !state.optionalsToDelete.includes(key)) state.optionalsToDelete.push(key)
	}
	function updateOptionals(items: Array<ObjectContext>) {
		state.optionals = JSON.parse(JSON.stringify(items))
	}

	const refForm = ref(null)

	async function onCreateItem() {
		// @ts-ignore
		const res = await refForm.value.validate()
		const valid = res.valid
		if (valid) {
			const action = isNew.value || isCopy.value ? 'create' : 'update'
			const tab = tabSelected.value
			try {
				const body = {
					...state.item
				}
				// @ts-ignore
				state.optionalsToDelete.forEach(key => (body[key] = null))
				// @ts-ignore
				state.optionals.forEach(e => (body[e.key] = e.value))
				const res = await $store.dispatch(`${tab}/${action}`, body)
				const data = res.data.response_json
				const id = data.warehouse_evaluation_id
				const routeName = $route.name
				$router.push({ name: routeName, params: { tab, id } })
				setStep()
			} catch (error) {
				console.log(`🚀 ~ onSaveItem ~ error`, error)
				$store.dispatch('alert/SET_ALERT', { action, error })
			}
		}
	}

	async function getProducts() {
		loading.value = true
		const item = await $store.dispatch('warehouses/get', state.item.warehouse_id)
		const items = item.warehouse_crops
		$store.commit('dictionary/SET_ALLOWED_VALUES', { key: 'warehouse_evaluation_crop_name', items })
		loading.value = false
	}

	async function validateStep() {
		let isValid = true
		// @ts-ignore
		const res = await refForm.value.validate()
		const isFormValid = res.valid
		if (!isFormValid) $store.dispatch('alert/SET_ALERT', { text: $t('Form_missing_required') })
		else if (formStep.value === 1) {
			if (!isNew.value) setStep()
			else if (state.item.warehouse_id) onCreateItem()
			else {
				$store.dispatch('alert/SET_ALERT', {
					// @ts-ignore
					text: $t('Form_entities_required', null, {
						entity: $t('General_warehouses').toLowerCase()
					})
				})
			}
		} else if (formStep.value === 2) {
			const keys = ['warehouse_evaluation_name']
			keys.forEach(key => {
				// @ts-ignore
				if ([undefined, null, ''].includes(state.item[key])) isValid = false
			})
			if (isValid) {
				await getProducts()
				setStep()
			}
		} else if (formStep.value === 3) {
			const keys = [
				'warehouse_evaluation_crop_name',
				'warehouse_evaluation_crop_processed_quantity',
				'warehouse_evaluation_crop_ready_made_quantity',
				'warehouse_evaluation_crop_finished_product_quantity',
				'warehouse_evaluation_crop_water_quantity',
				'warehouse_evaluation_crop_electricity_quantity',
				'warehouse_evaluation_crop_machinery_quantity'
			]
			keys.forEach(key => {
				// @ts-ignore
				if ([undefined, null, ''].includes(state.item[key])) isValid = false
			})

			if (isValid) state.confirmDialog = !state.confirmDialog
		}
		if (!isValid) $store.dispatch('alert/SET_ALERT', { text: $t('Form_missing_required') })
	}

	watch(mainClick, () => validateStep())

	async function onFinishForm(showPDF: boolean) {
		state.confirmDialog = false
		if (!showPDF) goToMainView()
		else {
			loading.value = true
			try {
				// @ts-ignore
				if (!state.item.is_warehouse_evaluation_completed) {
					const item: ObjectContext = Object.assign({}, state.item)
					item.is_warehouse_evaluation_completed = true
					const body_item = {
						_item: item,
						_keys: ['is_warehouse_evaluation_completed']
					}
					await $store.dispatch('warehouse_evaluations/update', body_item)
				}

				const body_report = {
					// @ts-ignore
					warehouse_evaluation_id: state.item.warehouse_evaluation_id,
					tabSelected: tabSelected.value
				}
				const url = await $store.dispatch('report/get', body_report)
				goToMainView()
				const alert = {
					url,
					timeout: 0,
					tab: 'report',
					action: 'download',
					color: 'success'
				}
				$store.dispatch('alert/SET_ALERT', alert)
			} catch (error) {
				$store.dispatch('alert/SET_ALERT', { action: 'get', error })
			} finally {
				loading.value = false
			}
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          ref_key: "refForm",
          ref: refForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window, {
              modelValue: _unref(formStep),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(formStep) ? (formStep).value = $event : null)),
              touchless: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(OGridSelectEntity, {
                          modelValue: _unref(state).item.warehouse_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).item.warehouse_id) = $event)),
                          "tab-selected": "warehouses",
                          disabled: !_unref(isNew)
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                  return _createVNode(_component_v_window_item, {
                    value: n + 1,
                    key: n
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: section.id
                        }, [
                          (section.expansion_panel)
                            ? (_openBlock(), _createBlock(_component_v_expansion_panels, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel, {
                                    class: "expansion-panel-section",
                                    value: section.panel
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, null, {
                                        default: _withCtx(() => [
                                          (section.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref($t)(section.title)), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_divider, { color: "primary_alt" }),
                                      _createVNode(_component_v_expansion_panel_text, null, {
                                        default: _withCtx(() => [
                                          (section.components)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(section.components, (sub_section) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "mt-4",
                                                  key: sub_section.id
                                                }, [
                                                  (sub_section.title)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref($t)(sub_section.title)), 1))
                                                    : _createCommentVNode("", true),
                                                  (sub_section.description)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref($t)(sub_section.description)), 1))
                                                    : _createCommentVNode("", true),
                                                  (sub_section.table)
                                                    ? (_openBlock(), _createBlock(MDynamicForm, {
                                                        key: 2,
                                                        modelValue: _unref(state).item,
                                                        table: "",
                                                        keys: sub_section.keys,
                                                        "tab-selected": _unref(tabSelected),
                                                        "size-columns-to-fit": sub_section.sizeColumnsToFit
                                                      }, null, 8, ["modelValue", "keys", "tab-selected", "size-columns-to-fit"]))
                                                    : (_openBlock(), _createBlock(_resolveDynamicComponent(sub_section.component), {
                                                        key: 3,
                                                        item: _unref(state).item,
                                                        type: sub_section.type
                                                      }, null, 8, ["item", "type"]))
                                                ]))
                                              }), 128))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (section.table)
                                                  ? (_openBlock(), _createBlock(MDynamicForm, {
                                                      key: 0,
                                                      modelValue: _unref(state).item,
                                                      table: "",
                                                      keys: section.keys,
                                                      "tab-selected": _unref(tabSelected),
                                                      "size-columns-to-fit": section.sizeColumnsToFit
                                                    }, null, 8, ["modelValue", "keys", "tab-selected", "size-columns-to-fit"]))
                                                  : (_openBlock(), _createBlock(_resolveDynamicComponent(section.component), {
                                                      key: 1,
                                                      item: _unref(state).item,
                                                      type: section.type
                                                    }, null, 8, ["item", "type"]))
                                              ], 64))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (section.title)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref($t)(section.title)) + " ", 1),
                                        _createVNode(_component_v_divider, {
                                          color: "primary_alt",
                                          class: "mt-4"
                                        })
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, {
                                  cols: section.id === 'warehouse_evaluation_name' ? 4 : 12
                                }, {
                                  default: _withCtx(() => [
                                    (section.components)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(section.components, (sub_section) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: sub_section.id
                                          }, [
                                            (sub_section.table)
                                              ? (_openBlock(), _createBlock(MDynamicForm, {
                                                  key: 0,
                                                  modelValue: _unref(state).item,
                                                  table: "",
                                                  keys: sub_section.keys,
                                                  "tab-selected": _unref(tabSelected),
                                                  "size-columns-to-fit": sub_section.sizeColumnsToFit
                                                }, null, 8, ["modelValue", "keys", "tab-selected", "size-columns-to-fit"]))
                                              : (_openBlock(), _createBlock(_resolveDynamicComponent(sub_section.component), {
                                                  key: 1,
                                                  item: _unref(state).item,
                                                  type: sub_section.type
                                                }, null, 8, ["item", "type"]))
                                          ], 64))
                                        }), 128))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (section.table)
                                            ? (_openBlock(), _createBlock(MDynamicForm, {
                                                key: 0,
                                                modelValue: _unref(state).item,
                                                table: "",
                                                keys: section.keys,
                                                "tab-selected": _unref(tabSelected),
                                                "size-columns-to-fit": section.sizeColumnsToFit
                                              }, null, 8, ["modelValue", "keys", "tab-selected", "size-columns-to-fit"]))
                                            : (_openBlock(), _createBlock(_resolveDynamicComponent(section.component), {
                                                key: 1,
                                                item: _unref(state).item,
                                                type: section.type
                                              }, null, 8, ["item", "type"]))
                                        ], 64))
                                  ]),
                                  _: 2
                                }, 1032, ["cols"])
                              ], 64))
                        ], 64))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }),
    _createVNode(TConfirmation, {
      modelValue: _unref(state).confirmDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).confirmDialog) = $event)),
      element: _unref(tabSelectedElement),
      "confirm-create": "",
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (onFinishForm(true))),
      onConfirmSecondary: _cache[4] || (_cache[4] = ($event: any) => (onFinishForm(false)))
    }, null, 8, ["modelValue", "element"])
  ], 64))
}
}

})